import { setFilters } from '@/app/common/reducers/filterSlice';
import type { AdvancedFiltersState } from '@/app/common/components/filters/filterTypes';
import { convertToQueryString } from '@/utils/queryString';
import {
  Button,
  Dropdown,
  Form,
  OverlayTrigger,
  Popover
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { useState, type FormEvent } from 'react';
import { difficulyRanges, serpDifficuly } from '@/helpers/serpDifficulity';

type FiltersRootState = {
  filters: AdvancedFiltersState;
};

const GapCustomDifficultyFilters = () => {
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [customStart, setCustomStart] = useState<string | number>(1);
  const [customLimit, setCustomLimit] = useState('');
  const currentFilters = useSelector(
    (state: FiltersRootState) => state.filters
  );
  const dispatch = useDispatch();
  const [, setSearchParams] = useSearchParams();
  const handleFilterClick = (start: number, limit: number) => {
    const filters: AdvancedFiltersState = {
      difficulty: {
        title: 'سختی ',
        operator: 'and',
        filterModes: [
          {
            mode: 'greaterthanorequals',
            value: `${start}`,
            key: 1
          },
          {
            mode: 'lessthanorequals',
            value: `${limit}`,
            key: 2
          }
        ]
      }
    };
    dispatch(setFilters({ ...currentFilters, ...filters }));
    setSearchParams(convertToQueryString({ ...currentFilters, ...filters }));
    setShowFilterMenu(false);
  };

  const handleCustomSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (customLimit) {
      handleFilterClick(Number(customStart), Number(customLimit));
    }
  };

  return (
    <OverlayTrigger
      show={showFilterMenu}
      trigger="click"
      onToggle={() => setShowFilterMenu(false)}
      rootClose
      placement="top"
      overlay={
        <Popover
          id="custom_filter_menu"
          className="react-select__menu"
          style={{ maxWidth: '100%', minWidth: 200 }}
        >
          <style>
            {`
            #custom_filter_menu .popover-arrow{ display:none }
            `}
          </style>
          <Popover.Body className="p-2">
            {difficulyRanges.map(([start, end]) => (
              <Dropdown.Item
                className="link-600 fs--1 border-bottom justify-content-between d-flex align-items-center gap-1 p-1"
                key={start}
                onClick={() => handleFilterClick(start, end)}
              >
                <span>{serpDifficuly(start).label}</span>
                <span dir="ltr">
                  {start}-{end} %
                </span>
              </Dropdown.Item>
            ))}
            <div onClick={e => e.stopPropagation()} className="p-2 mt-2">
              <Form onSubmit={handleCustomSubmit}>
                <Form.Label> بازه دلخواه </Form.Label>
                <div className="input-group position-relative input-group-sm">
                  <Form.Control
                    size="sm"
                    type="number"
                    placeholder="از"
                    style={{ width: 50 }}
                    value={customStart}
                    onChange={e => setCustomStart(e.target.value)}
                  />
                  <Form.Control
                    size="sm"
                    type="number"
                    style={{ width: 50 }}
                    placeholder="تا"
                    value={customLimit}
                    onChange={e => setCustomLimit(e.target.value)}
                  />
                </div>
                <Button
                  type="submit"
                  size="sm"
                  variant="falcon-primary"
                  className="mt-2 w-100"
                >
                  اعمال
                </Button>
              </Form>
            </div>
          </Popover.Body>
        </Popover>
      }
    >
      <Button
        size="lg"
        variant="secondary"
        onClick={() => setShowFilterMenu(s => !s)}
        className="m-0 fs-0 h-100 cursor-pointer d-flex align-items-center"
      >
        سختی کلمه
      </Button>
    </OverlayTrigger>
  );
};

export default GapCustomDifficultyFilters;
